import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductCommissions', request)
}

async function put(request) {
    return await putMethod('/api/ownProductCommissions', request)
}

async function post(body) {
    return await postMethod('/api/ownProductCommissions', body)
}

export {get, put, post}
